import React from 'react';
import { useDroppable, useDraggable } from '@dnd-kit/core';
import { API_BASE_URL } from '../../../config';
import { fetchJson } from '@utils/fetchJson';
import { GripVertical, X } from 'lucide-react';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
const DraggableField = ({ onDelete,field }) => {
  const { attributes, listeners, setNodeRef, transform,isDragging } = useDraggable({
    id: `available-${field.fieldID}`,
    data: {
      type: 'field',
      field,
    },
  });

  const style = {
    transform: transform ? `translate(${transform.x}px, ${transform.y}px)` : undefined,
    opacity: isDragging ? 0.4 : 1,
  };
   
  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex items-center justify-between p-3 border rounded bg-white shadow cursor-grab hover:bg-gray-50 transition"
      title={`Drag "${field.fieldLabel}" to a column`}
    >
      <div className="flex items-center gap-2">
        <span {...attributes} {...listeners} className="cursor-move text-gray-400">
                  <GripVertical size={16} />
                </span>
        {/* <GripVertical size={16} className="text-gray-400" /> */}
        <div>
          <div className="font-medium text-gray-800">{field.fieldLabel}</div>
          <div className="text-xs text-gray-500">{field.fieldType}</div>
        </div>
        <div className="flex gap-2">
          <button onClick={() => onDelete(field)} title="Delete Field" className="text-red-500">
          <X size={16} />
        </button>
      </div>
      </div>
    </div>
  );
};
export default function AvailableFields({ updateFields,fields = [] }) {
  const { setNodeRef, isOver } = useDroppable({
    id: 'available-fields',
    data: { type: 'available-zone' },
  });
  //  const handleDeleteFromDB = async (field) => {
  //     if (!window.confirm(`Delete "${field.fieldLabel}" permanently?`)) return;
  //     try {
  //       const res = await fetchJson(`${API_BASE_URL}/dynamicformfield/status`, {
  //         method: 'POST',
  //         body: JSON.stringify({ list: field.fieldID,action:"changeStatus",status:"delete" }),
  //       });
  //       if (res.flag === 'S') {
  //         updateFields(field);
  //         toast.success('Deleted');
  //       } else toast.error(res.msg || 'Failed');
  //     } catch {
  //       toast.error('Server error');
  //     }
  //   };
  const handleDeleteFromDB = async (field) => {
  const result = await Swal.fire({
    title: `Delete “${field.fieldLabel}”?`,
    html: `
      <div style="text-align:left">
        <p>This will <b>permanently delete</b> the field and all its stored data across records.</p>
        <p style="color:#b91c1c"><b>This action cannot be undone.</b> You will not be able to retrieve the data again.</p>
      </div>
    `,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete permanently',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#d33',
    reverseButtons: true,
    focusCancel: true,
  });

  if (!result.isConfirmed) return;

  // Optional: show a modal loader while deleting
  await Swal.fire({
    title: 'Deleting…',
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => Swal.showLoading(),
  });

  try {
    const res = await fetchJson(`${API_BASE_URL}/dynamicformfield/status`, {
      method: 'POST',
      body: JSON.stringify({ list: field.fieldID, action: 'changeStatus', status: 'delete' }),
      // headers: { 'Content-Type': 'application/json' }, // add if your fetchJson doesn't set it
    });

    Swal.close();

    if (res.flag === 'S') {
      updateFields(field);
      toast.success('Field deleted permanently.');
    } else {
      toast.error(res.msg || 'Failed to delete field.');
    }
  } catch (e) {
    Swal.close();
    toast.error('Server error while deleting.');
  }
};

  return (
    <div
      ref={setNodeRef}
      className={`p-4 space-y-2 h-full border rounded shadow mb-6 transition-colors ${
        isOver ? 'bg-blue-100 border-blue-400' : 'bg-gray-50'
      }`}
    >
      <h2 className="text-md font-semibold text-gray-700">Available Fields</h2>
      {fields.length > 0 ? (
        fields.map((field) => (
          <DraggableField key={field.fieldID} onDelete={handleDeleteFromDB} field={field} />
        ))
      ) : (
        <div className="text-sm text-gray-400 text-center">All fields used</div>
      )}
    </div>
  );
}
